import { css } from '@emotion/core';
export var avatarIcon = {
  name: "180lulx",
  styles: "stroke-linejoin:round;stroke-linecap:round;fill:none;vertical-align:middle;use{pointer-events:none;}"
};